import { useQuery } from 'react-query';
import { useParams, useLocation } from 'react-router-dom';
import { apiGetCollectionPageData } from '../../../api/apiCollections';
import { apiGetDesignsInCollection } from '../../../api/apiDesigns';
import LoadingScreen from '../loading/LoadingScreen';
import TextHeader from '../../textHeader/TextHeader';
import Gallery from '../gallery/Gallery';
import { useEffect } from 'react';
import MissingPage from '../errorMessages/MissingPage';
import DesignsInCollectionGrid from '../grid/DesignsInCollectionGrid';
import { captureAnalytics } from '../../../utilities/Analytics';
import CarouselBanner from '../banner/CarouselBanner';

function CollectionTemplate() {
  const { item_group, application, collection } = useParams();
  const location = useLocation();

  const argumentDataStructure = {
    category: {
      application: application,
      item_group: item_group,
      collection: collection,
    },
  };

  // 🔥 UPDATED: Modified filter to get ALL applications for this collection
  const designFilters = {
    filters: {
      item_group: item_group,
      // 🔥 REMOVED: application filter to get products from ALL applications
      // application: application ? [application] : undefined,
      range: collection,
    },
    filter_fields: [
      "application",
      "item_group",
      "range",
      "brand",
      "web_colour",
      "design_style",
      "web_materials",
      "web_shape",
      "web_size",
      "web_type",
      "web_standards"
    ],
    main_filter_field: null,
    selection_fields: null,
    sort_by_setting: "Alphabetical A-Z",
    off_setter: {
      start: 0,
      end: 1000, // 🔥 INCREASED: Get more products to ensure we get all applications
    },
    only_published: true,
    only_promo: false,    // Consumer repo specific
    only_in_stock: false,
    limited: true,
  };

  const {
    isLoading,
    isError,
    isSuccess,
    data: collectionData,
  } = useQuery([`collection-${collection}`], () =>
    apiGetCollectionPageData(argumentDataStructure)
  );

  // 🔥 UPDATED: Modified query key to not include application so it's shared between URLs
  const { data: designsData } = useQuery(
    [`collection-designs-${collection}-${item_group}`], // Removed application from key
    () => apiGetDesignsInCollection(designFilters)
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    captureAnalytics(
      'pageview',
      location.pathname,
      `Collection - ${collection}`
    );
  }, [location.pathname, collection]);

  // 🔥 NEW: Debug log to see what applications we're getting
  useEffect(() => {
    if (designsData?.products) {
      const applications = Array.from(new Set(designsData.products.map((p: any) => p.application)));
      console.log('Applications found in collection:', applications);
      console.log('Total products:', designsData.products.length);
    }
  }, [designsData]);

  return (
    <>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          {isError && <MissingPage />}

          {isSuccess && (
            <>
              <CarouselBanner
                heroImages={collectionData?.section_consumer_hero}
                heroVideo={collectionData?.section_consumer_hero_video ? {
                  video_url: collectionData.section_consumer_hero_video.video_url,
                  thumbnail_url: collectionData.section_consumer_hero_video.thumbnail_url || ''
                } : undefined}
                heroLink={collectionData?.section_consumer_hero_link}
                videoLink={collectionData?.section_consumer_video_link}
                displayOption={collectionData?.consumer_display_option}
                bannerWidth={collectionData?.consumer_banner_width}
                bannerHeight={collectionData?.consumer_banner_height}
              />
              <TextHeader
                heading={collectionData?.page_title}
                content={collectionData?.description}
                isCentered={false}
                width="70%"
                marginTop={10}
                marginBottom={5}
              />
              <Gallery
                images={collectionData?.section_gallery}
                galleryLayout={'masonry'}
                columns={2}
                title={'title'}
                secondaryText={'2bd'}
                hasTitle={false}
                hasSecondaryText={false}
              />
              {/* !Client has requested a change on this component, we may need to revert the DesignsGrid component */}
              <DesignsInCollectionGrid
                data={designsData} // Pass the whole object, not just products array
                marginTop="5rem"
                marginBottom="5rem"
              />
            </>
          )}
        </>
      )}
    </>
  );
}

export default CollectionTemplate;